export default __webpack_public_path__ + "static/media/@inaccuracy.04f5c24d.svg";